export const PREV_WINNERS = {
    roty2025: {
        image: '2025-winners/winners_2025.jpg',
        name: 'Silver\'s Deli',
        location: 'Yorkshire',
        instagram: 'https://www.instagram.com/silvers_deli/',
        sharelink: 'www.ubereats.com/store/silvers-deli/xxZ-fZERVbysNJzeq5Y6Mg',
        orderlink: 'www.ubereats.com/store/silvers-deli/xxZ-fZERVbysNJzeq5Y6Mg',
    },
    /* roty2024: {
        image: '2024-winners/roty-winner-2024_final.jpg',
        name: 'Natty\'s Jerk',
        location: 'South East',
        instagram: 'https://www.instagram.com/nattysjerk/',
        sharelink: 'https://www.ubereats.com/gb/store/nattys-jerk-shack/wfwaS8mQTnKGRGcaoPLulg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkJyaWdodG9uJTIyJTJDJTIycmVmZXJlbmNlJTIyJTNBJTIyQ2hJSlowRXA5Z21GZFVnUi1RNTljbnF2eHB3JTIyJTJDJTIycmVmZXJlbmNlVHlwZSUyMiUzQSUyMmdvb2dsZV9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQTUwLjgyMjk0MDIlMkMlMjJsb25naXR1ZGUlMjIlM0EtMC4xMzYyNjcyJTdE',
        orderlink: 'https://www.ubereats.com/gb/store/nattys-jerk-shack/wfwaS8mQTnKGRGcaoPLulg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkJyaWdodG9uJTIyJTJDJTIycmVmZXJlbmNlJTIyJTNBJTIyQ2hJSlowRXA5Z21GZFVnUi1RNTljbnF2eHB3JTIyJTJDJTIycmVmZXJlbmNlVHlwZSUyMiUzQSUyMmdvb2dsZV9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQTUwLjgyMjk0MDIlMkMlMjJsb25naXR1ZGUlMjIlM0EtMC4xMzYyNjcyJTdE',
    }, */
    femaleChef2025: {
        image: 'trailblazers/2025/laura-stone.jpg',
        name: 'Laura Stone',
        restaurant: 'Laura\'s Pizzas',
        location: 'South West',
        instagram: 'https://www.instagram.com/lauraspizzas/',
        sharelink: 'https://www.ubereats.com/store/lauras-pizzas/ibeXRAvCXla3b5Hj3SHlWQ',
        orderlink: 'https://www.ubereats.com/store/lauras-pizzas/ibeXRAvCXla3b5Hj3SHlWQ',
    },
    /* femaleChef2024: {
        image: '2024-winners/sarah-ibrahim-2024.jpg',
        name: 'Sarah Ibrahim',
        restaurant: 'Smoke & Pepper',
        location: 'London',
        instagram: 'https://www.instagram.com/smokeandpepperldn/',
        sharelink: 'https://www.ubereats.com/gb/store/smoke-%26-pepper-bow/CKERs5jqWyCOcj5-u_sw-A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D',
        orderlink: 'https://www.ubereats.com/gb/store/smoke-%26-pepper-bow/CKERs5jqWyCOcj5-u_sw-A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D',
    }, */
    sustainable2025: {
        image: 'trailblazers/2025/hogless-roast.jpg',
        name: 'The Hogless Roast',
        // restaurant: 'Loki Poke',
        location: 'London',
        instagram: 'https://www.instagram.com/thehoglessroast/',
        sharelink: 'https://www.ubereats.com/store/the-hogless-roast-vegan/iAcImHboT_qEXCSnEDSl0A',
        orderlink: 'https://www.ubereats.com/store/the-hogless-roast-vegan/iAcImHboT_qEXCSnEDSl0A',
    },
    /* sustainable2024: {
        image: '2024-winners/loki-poki-2024.jpg',
        name: 'Loki Poke',
        // restaurant: 'Loki Poke',
        location: 'Bristol',
        instagram: 'https://www.instagram.com/lokipokeuk/?hl=en',
        sharelink: 'https://www.ubereats.com/gb/store/loki-poke/ktD1gfGzUsqeBJ2kz379zA?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/loki-poke/ktD1gfGzUsqeBJ2kz379zA?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    }, */
    socialImpact2025: {
        image: 'trailblazers/2025/piatto.jpg',
        name: 'Piatto',
        // restaurant: 'Burger Drop',
        location: 'Scotland',
        instagram: 'https://www.instagram.com/piatto44/',
        sharelink: 'https://www.ubereats.com/store/piatto/6hxxP8b-RHCu2Btfr3Xkaw',
        orderlink: 'https://www.ubereats.com/store/piatto/6hxxP8b-RHCu2Btfr3Xkaw',
    },
    /* socialImpact2024: {
        image: '2024-winners/burger-drop-2024.jpg',
        name: 'Burger Drop',
        // restaurant: 'Burger Drop',
        location: 'Newcastle',
        instagram: 'https://www.instagram.com/burgerdropuk/',
        sharelink: 'https://www.ubereats.com/gb/store/burger-drop-westgate-road/uwcKQAubQSy0UbcvHrYovg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/burger-drop-westgate-road/uwcKQAubQSy0UbcvHrYovg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    }, */
    health2025: {
        image: 'trailblazers/2025/eat-clean.jpg',
        name: 'Eat Clean',
        // restaurant: 'Urban Health',
        location: 'North East',
        instagram: 'https://www.instagram.com/eatclean.uk',
        sharelink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
        orderlink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
    },
    /* health2024: {
        image: '2024-winners/urban-health-2024.jpg',
        name: 'Urban Health',
        // restaurant: 'Urban Health',
        location: 'Dublin',
        instagram: 'https://www.instagram.com/urbanhealth_ie/?hl=en',
        sharelink: 'https://www.ubereats.com/ie/store/urban-health-ranelagh/tIVWYXUsUcW7dA4C3FngQw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/ie/store/urban-health-ranelagh/tIVWYXUsUcW7dA4C3FngQw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    }, */
    /* roty2023: {
        image: '2023-winners/roty-winner-2023.jpg',
        name: 'Sandwich Sandwich',
        location: 'South West',
        instagram: 'https://www.instagram.com/sandwichsandwichuk/',
        sharelink: 'https://www.ubereats.com/',
        orderlink: 'https://www.ubereats.com/gb/store/sandwich-sandwich/ZJDtRp6YUSm4WkBCPMoUvw',
        // orderlink: 'https://www.ubereats.com/gb/store/sandwich-sandwich/nTRTKalkS6m1rvcWocu2tw',
    },
    femaleChef2023: {
        image: '2023-winners/female-chef-2023.jpg',
        name: 'Natalie Francis',
        restaurant: "Doreen's Kitchen",
        location: 'Midlands and East Anglia',
        instagram: 'https://www.instagram.com/_doreenskitchen_/',
        sharelink: 'https://www.ubereats.com/',
        orderlink: 'https://www.ubereats.com/gb/store/doreens-kitchen/ChrLevRMWZGgsYHKEtZaVA',
    },
    sustainable2023: {
        image: '2023-winners/sustainable-2023.jpg',
        name: 'Aled Hill and Shaun Jones',
        restaurant: 'ANSH CYMRU',
        location: 'Wales',
        instagram: 'https://www.instagram.com/anshcymru/',
        sharelink: 'https://www.ubereats.com/',
        orderlink: 'https://www.ubereats.com/gb/store/ansh/UavR62baUqyOQCpMC9t9sg',
    },
    health2023: {
        image: '2023-winners/health-2023.jpg',
        name: 'Henri Salameh and Emile Salame',
        restaurant: 'Eat Lebö',
        location: 'London',
        instagram: 'https://www.instagram.com/eatlebo/',
        sharelink: 'https://www.ubereats.com/',
        orderlink: 'https://www.ubereats.com/gb/store/eat-lebo-ruislip',
    },
    community2023: {
        image: '2023-winners/community-2023.jpg',
        name: 'Rashpal Singh',
        restaurant: 'Taste From India',
        location: 'Midlands and East Anglia',
        instagram: 'https://www.instagram.com/tasteofindia/',
        sharelink: 'https://www.ubereats.com/',
        orderlink: 'https://www.ubereats.com/gb/store/taste-of-india/Ud7NNE8vS72nip4O4j177A',
    } */
    nextGen2025: {
        image: 'trailblazers/2025/aros.jpg',
        name: 'Aros',
        restaurant: 'Aros Kitchen',
        location: 'North West',
        instagram: 'https://www.instagram.com/aros_kitchen/',
        sharelink: 'https://www.ubereats.com/store/aros-kitchen-warrington/VvVcFOs7XA6jjLjeatESzg',
        orderlink: 'https://www.ubereats.com/store/aros-kitchen-warrington/VvVcFOs7XA6jjLjeatESzg',
    }
}